import React from 'react'
import { useFormik } from 'formik'
import Logo from '../../../assets/logoN2.png';
import { Button, Grid, TextField } from '@mui/material';
import { Box } from '@mui/system';
import firebase from "firebase/app";
import { useHistory } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import { resetPasswordValidation } from "../../../validators/resetPassword";
import { Link } from 'react-router-dom';
import MainLayoutWrapper from '../../../components/wrappers/mainLayoutWrapper';
import { toast } from "react-toastify";
const ForgetPasswordModal = styled.div`
    display: flex;
    flex-direction: column;
    width: 70vw;
    border-radius: 15px;
    align-items: center;
`;
const ForgetPasswordActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 25px;
    width: 55vw;
`;
const ForgetPassword = () => {
    const [gender, setGender] = React.useState('');
    const history = useHistory();

    const { t, i18n } = useTranslation();
    const handleReset = (loginDto) => {
        firebase.firestore().collection('users').where('email', '==', loginDto.email).get().then(result => {
            if (result && result.docs.length) {
                firebase.auth().sendPasswordResetEmail(loginDto.email)
                    .then(result => {
                        console.log("done")
                        toast.success(`Check your email! \n\n You will recieve an email to reset your password, Thank you`, {onClose:()=>  history.push("/")});
                      
                    }).catch(err => {
                        console.log("error : ",err);
                        toast.error(`Oops! \n\n Could not send a password reset email, Please try again!`);
                    })
            } else {
                console.log("error : Could not find your user, Are you sure you are registered ?")
                toast.error(`Oops! \n\n Could not find your user, Are you sure you are registered ?`);
            }
        }).catch(err => {
            console.log("error : ",err)
            toast.error(`Oops! \n\n Could not find your user, Are you sure you are registered ?`);
        })
    }
    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: resetPasswordValidation,
        onSubmit:handleReset
    })
    return (
        <MainLayoutWrapper>
            <ForgetPasswordModal>
            <img src={Logo} style={{
                width: 360,
                height: 360,
                backgroundSize: 'contain',
            }} />
                <div className='formContainer'>
                    <TextField
                        id="outlined-email"
                        label="Email"
                        variant="outlined"
                        type={'email'}
                        className='formInput'
                        autoCapitalize='none'
                        autoCorrect='none'
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                        helperText={formik.errors.email}
                        error={!!formik.errors.email}
                    />
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '30ch' },
                        }}
                        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                        noValidate
                        autoComplete="off">
                        <Button className='submitBtn' style={{ width: "100%" }} onClick={formik.handleSubmit} disabled={!formik.isValid} variant="contained">Reset</Button>
                    </Box>
                </div>
            </ForgetPasswordModal>
            <ForgetPasswordActions>
                <Link to={'/'}>Back to sign in!</Link>
            </ForgetPasswordActions>
        </MainLayoutWrapper>
    )
}

export default ForgetPassword;